import { DatePicker } from './DatePicker';
import type { BasePickerPanelProps, DatePickerProps } from './types';

type Props = DatePickerProps & Partial<BasePickerPanelProps>;

export function TimeDatePicker({
  format = 'YYYY-MM-DD HH:mm',
  placeholder = 'Select DateTime',
  ...rest
}: Props) {
  return <DatePicker format={format} placeholder={placeholder} showTime {...rest} />;
}
